/* import __COLOCATED_TEMPLATE__ from './sq-field-select-state.hbs.js'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { t } from '@dashboard/i18n/macros';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  countries: service(),
  userInfo: service(),
  prompt: t('statesSelect.prompt'),
  content: computed('userInfo.countryCode', function () {
    const stateNames = this.countries.stateNamesByCodeForCountryCode(this.userInfo.countryCode);
    if (!stateNames) {
      return [];
    } else {
      return Object.entries(stateNames).map(([code, stateName]) => ({
        value: code,
        label: stateName
      })).sort((a, b) => a.label.localeCompare(b.label, this.userInfo.countryCode, {
        sensitivity: 'base'
      }));
    }
  })
});